import { Box, Button, Dialog, Typography } from '@material-ui/core'
import { useState } from 'react'

import ImportIcon from 'mdi-material-ui/Import'
import ManaWorld from '../../logic/loop/ManaWorld'
import MGLoader from '../../logic/saves/MGLoader'


export default function TooltipImport({ title = undefined as any, currentManaWorld, onChange }: { title?: any, currentManaWorld: ManaWorld, onChange: (newManaWorld: ManaWorld) => void }) {
	const [loadError, setLoadError] = useState(false)

	return (

		<Box display="flex" gridGap="8px" justifyContent="space-between" alignItems="center">
			<Typography variant="subtitle2">{title}</Typography>
			<Button
				variant="contained"
				color="primary"
				disableElevation
				component="label"
				startIcon={<ImportIcon />}
			>
				<Typography>Import</Typography>
				<input type="file" hidden accept=".json" onChange={(e) => {
					if (currentManaWorld) {
						const file = e.target?.files?.[0]
						if (file) {
							const fr = new FileReader()
							fr.onload = () => {
								try {
									const json = JSON.parse(fr.result as string)

									const manaWorld = new ManaWorld(currentManaWorld.caster, currentManaWorld.caster.world)

									// load file
									MGLoader.loadManaWorld(json, manaWorld)

									onChange(manaWorld)

								} catch (err) {
									setLoadError(true)
									console.error(err)
								}
							}
							fr.readAsText(file)
						}
					}
				}} />
			</Button>

			{/* import error */}
			<Dialog open={loadError} onClose={() => setLoadError(false)}>
				<Box p="1rem">
					Failed to load file
				</Box>
			</Dialog>
		</Box>
	)
}
